// extracted by mini-css-extract-plugin
export default {"wrapper":"BPMarkdown_wrapper__HPxAy"};